import { createContext, useContext, useState, type FC, type ReactNode } from "react";

interface LawyerSignupState {
  email: string;
  password: string;
  setCredentials: (email: string, password: string) => void;
  clearCredentials: () => void;
}

const LawyerSignupContext = createContext<LawyerSignupState | null>(null);

export const LawyerSignupProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const setCredentials = (e: string, p: string) => {
    setEmail(e);
    setPassword(p);
  };

  const clearCredentials = () => {
    setEmail("");
    setPassword("");
  };

  return (
    <LawyerSignupContext.Provider value={{ email, password, setCredentials, clearCredentials }}>
      {children}
    </LawyerSignupContext.Provider>
  );
};

export function useLawyerSignup(): LawyerSignupState {
  const context = useContext(LawyerSignupContext);
  if (!context) {
    throw new Error("useLawyerSignup must be used within LawyerSignupProvider");
  }
  return context;
}
